<template>
  <div class="active_table" ref="content">
    <div class="table">
      <h1>应急物资分布</h1>
      <br>
      <img src="/contingency/wuzifenbu.png" alt="应急物资分布图">
    </div>
  </div>
</template>
  
<style lang="scss" scoped>
.active_table {
  width: 100%;
  height: 100%;
  padding-top: 2em;
}

.table {
  padding: 0 1em;
  width: 100%;
  height: calc(100% - 5.5em);
  position: relative;
}

.content {
  width: 700px;

  img {
    height: 100%;
  }
}
</style>

<script>


export default {
  data() {
    return {
      arr: [],
    };
  },
  components: {
  },
  created: function () {
  },
  methods: {
  },
};
</script>